module.exports = __webpack_public_path__ + "img/product4.58df464a.png";